jQuery(function ($) {
  const sections = $('[data-logos]');

  $.each(sections, function () {
    const section = $(this);

    const swiper = new Swiper(section.find('.swiper-container').get(0), {
      slidesPerView: 1,
      spaceBetween: 16,
      centerInsufficientSlides: true,
      watchOverflow: true,
      breakpoints: {
        320: {
          slidesPerView: 2
        },
        480: {
          slidesPerView: 3,
          spaceBetween : 32
        },
        768: {
          slidesPerView: 4,
          spaceBetween : 32
        },
        1024: {
          slidesPerView: 4,
          spaceBetween : 32
        }
      },
      pagination: {
        el       : section.find('.swiper-pagination').get(0),
        type     : 'bullets',
        clickable: true
      }
    });

  });
});
